module.exports = __webpack_public_path__ + "img/card-t6.fa94fec3.png";